import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'components/UI/Heading/Heading';
import IconCard from 'components/IconCard/IconCard';
import AmenitiesWrapper, { AmenitiesArea } from './Amenities.style';
import { Element } from 'react-scroll';

const Amenities = ({ titleStyle, data }) => {
  console.log(data)
  return (
    <Element name="amenities" className="Amenities">
      <AmenitiesWrapper>
        <Heading as="h2" content="Equipements" {...titleStyle} />
        <AmenitiesArea>
        {data.map(item => (
          // <IconCard icon={item?.icone??icon} title={item.libelle} />
          <IconCard icon={item?.idIcone} title={item.libelle} />
      ))}
        </AmenitiesArea>
        {/* <TextButton>
          <TextLink link="#1" content="Vi" {...linkStyle} />
        </TextButton> */}
      </AmenitiesWrapper>
    </Element>
  );
};

Amenities.propTypes = {
  titleStyle: PropTypes.object,
  linkStyle: PropTypes.object,
};

Amenities.defaultProps = {
  titleStyle: {
    color: '#2C2C2C',
    fontSize: ['17px', '20px', '25px'],
    lineHeight: ['1.15', '1.2', '1.36'],
    mb: ['14px', '20px', '30px'],
  },
  linkStyle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#008489',
  },
};

export default Amenities;
